<template>
  <div id="gift_ordered_popup" class="gift_ordered_popup popup_container" style="display: none;">
    <div class="popup_cont">
      <div class="text text--big" v-html="message"></div>
    </div>
  </div>
</template>

<script>
let $=window.$ || {};
export default {
  name: "GiftPopup",
  props:{
    message: String,
  },
  data : () => ({
    popupOpened : false,
  }),
  mounted()
  {
    this.open();
  },
  methods : {
    open () {
      if (!this.popupOpened) {
        this.popupOpened = true;
        let self = this;
        $.fancybox({
          href : '#gift_ordered_popup',
          closeBtn : true,
          closeClick  : true,
          beforeShow() {
            $('body').addClass('fancybox-active');
          },
          afterShow(){},
          afterClose(){
            $('body').removeClass('fancybox-active');
            self.$parent.modal.show = false;
            // $.fancybox({href : '#gift_ordered_popup'}).close();
          },
        });
      }
    },
  },
}
</script>